<template lang="pug">
  tr(
    v-on="wrappedListeners"
    v-bind="config.attrs"
  )
    td(
      v-for="(column, idx) in scopedItem.headers"
      :key="idx"
      :colspan="column.colspan"
      :class="[column.align ? `t-table-row--${column.align}` : '', column.value === 'data-table-select' ? 't-table-row--center' : '']"
    )
      v-simple-checkbox(
        v-if="column.value === 'data-table-select'"
        color="#8F257D"
        :value="scopedItem.isSelected"
        @input="scopedItem.select(!scopedItem.isSelected)"
        :data-test="`row-checkbox-${scopedItem.index}`"
      )
      t-orm-table-actions(
        v-else-if="column.value === 'actions'"
        :actions="actions"
        :item="scopedItem.item"
        :config="config.actions"
        :row-index="scopedItem.index"
      )
      component(
        v-else-if="column.component"
        :is="column.component"
        :item="scopedItem.item"
        :value="handleValue(column, scopedItem.item)"
        :row-index="scopedItem.index"
        v-bind="column.componentProps"
      )
      div(v-else) {{ handleValue(column, scopedItem.item) }}
</template>

<script>
import EDocumentsStatus from '~/modules/documents/components/elements/e-documents-status'
import BlockDocumentsStatusAndSendDate from '~/modules/documents/components/blocks/pro-version/block-documents-status-and-send-date'
import TOrmTableActions from '~/components/templates/orm/t-orm-table-actions'
import ETextWithIcon from '~/components/elements/text/e-text-with-icon'
import EDocumentTitleWithTags from '~/modules/documents/components/elements/e-document-title-with-tags'
import ELinkEntityPage from '~/components/elements/links/e-link-entity-page'
import EStatusChip from '~/components/elements/e-status-chip'
import EHtmlInsert from '~/components/elements/e-html-insert'
import EChipStatusTooltip from '~/components/elements/chips/e-chip-status-tooltip'
import ETwoValuesTableColumnText from '~/components/elements/e-two-values-table-column-text'

export default {
  name: 'TTableRow',
  components: {
    TOrmTableActions,
    EDocumentsStatus,
    ETextWithIcon,
    EDocumentTitleWithTags,
    ELinkEntityPage,
    EStatusChip,
    EHtmlInsert,
    EChipStatusTooltip,
    ETwoValuesTableColumnText,
    BlockDocumentsStatusAndSendDate
  },
  props: {
    scopedItem: {
      type: Object,
      default: () => ({})
    },
    actions: {
      type: Array,
      default: () => []
    },
    config: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    wrappedListeners() {
      if (!this.config.listeners) {
        return null
      }
      return Object.keys(this.config.listeners || {}).reduce((acc, event) => {
        acc[event] = eventObj => this.config.listeners[event](eventObj, this.scopedItem.item)
        return acc
      }, {})
    }
  },
  methods: {
    handleValue(column, item) {
      if (column.valueFormatter && this._.isFunction(column.valueFormatter)) {
        return column.valueFormatter(item)
      }
      return this._.get(item, column.value) || '-'
    }
  }
}
</script>

<style scoped lang="scss">
.t-table-row {
  &--end {
    text-align: right;
  }

  &--start {
    text-align: left;
  }

  &--center {
    text-align: center;
  }
}
</style>
